import { Controller } from "@hotwired/stimulus"

// Phase 2.8 Tier 3 — placeholder client controller for the diff view.
// The server already renders the full diff inline; this controller
// exists so the dom can keep diff payload state for future
// row-collapse / filter-by-column UX without a server round-trip.
//
// Currently it just exposes the parsed payload via `this.payload` for
// any downstream behaviors (CSV export of just the diff, etc.).
export default class extends Controller {
  static values = { payload: { type: Object, default: {} } }

  connect() {
    this.payload = this.payloadValue || {}
    if (this.payload.truncated) {
      this.element.classList.add("data-truncated")
    }
  }
}
